import {Injectable} from '@angular/core';
import {Tenant} from '../interfaces/tenant';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {ServiceAnswer, ServiceAnswerAny} from '../../shared/service-answer';
import {GeneralService} from './general.service';
import {UiSettingsService} from '../../shared/ui-settings.service';
import { SuperuserServiceModule } from '../superuser-service.module';

/**
 * The service for application cache.
 */
@Injectable({
  providedIn: SuperuserServiceModule
})
export class ApplicationCacheService extends GeneralService<Tenant> {

  constructor(http: HttpClient, uiSettingService: UiSettingsService) {
    super(http, uiSettingService, 'applicationcache', 'applicationcache');
  }

  /**
   * Executes application cache removing.
   */
  public async removeApplicationCache(): Promise<ServiceAnswerAny> {
    return await this.executeHttpRequest(
      url => this.removeApplicationCacheSingle(url),
      null
      );
  }

  /**
   * Removes the application cache.
   */
  public async removeApplicationCacheSingle(url: string): Promise<ServiceAnswerAny> {
    const serviceAnswer: ServiceAnswerAny = {isOk: null};

    try {
      const entityObject = await this.http.delete(
        `${url}`,
        {
        })
        .pipe(
          map((value: any) => {
            return JSON.stringify(value);
          }))
        .toPromise();
      serviceAnswer.isOk = true;
      serviceAnswer.data = JSON.parse(entityObject);
      return serviceAnswer;
    } catch (error) {
      console.error(`Error when deleting the application cache: ${JSON.stringify(error)}`);
      serviceAnswer.isOk = false;
      serviceAnswer.errorCode = error.status;
      serviceAnswer.errorMessage = error.message + '. Answer body: ' + JSON.stringify(error.error);
      return serviceAnswer;
    }
  }
}
